export const getAlertColors = (type, theme) => {
  const colors = theme && theme.colors ? theme.colors : { 
    feedback: { info: '#17a2b8', success: '#28a745', warning: '#ffc107', error: '#dc3545' },
    brand: { primary: '#0056b3' }
  };
  
  switch (type) {
    case 'success':
      return { bg: `${colors.feedback.success}22`, border: colors.feedback.success, text: '#155724' };
    case 'warning':
      return { bg: `${colors.feedback.warning}33`, border: colors.feedback.warning, text: '#856404' };
    case 'error':
    case 'danger':
      return { bg: `${colors.feedback.error}22`, border: colors.feedback.error, text: '#721c24' };
    case 'info':
    default:
      return { bg: `${colors.feedback.info}22`, border: colors.feedback.info, text: '#0c5460' };
  }
};

export const getAlertIcon = (type) => {
  switch (type) {
    case 'success': return 'check-circle';
    case 'warning': return 'exclamation-triangle';
    case 'error':
    case 'danger': return 'times-circle';
    case 'info':
    default: return 'info-circle';
  }
};



// WEBPACK FOOTER //
// ./src/design-system/molecules/AlertInfo/utils/alertInfoHelpers.js